export default function getInt(num: string): number | null {
    let parsed = Number.parseInt(num, 10);
    parsed = Number.isNaN(parsed) ? null : parsed;
    parsed = Number.isFinite(parsed) ? parsed : null;
    return parsed;
}
